import { CustomModal } from 'components/uikit/modal/CustomModal';
import { BaseNode } from 'helpers/documents/types/base';
import { DeleteItemModal } from '../../deleteFolder/DeleteItemModal';

type TreeItemDeleteModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  item: BaseNode;
  projectId: number;
  revisionId: number;
  onDelete: () => Promise<void>;
};

export const TreeItemDeleteModal = ({
  isOpen,
  onClose,
  title,
  item,
  projectId,
  revisionId,
  onDelete,
}: TreeItemDeleteModalProps) => (
  <CustomModal
    isOpen={isOpen}
    onClose={onClose}
    isBlocking={true}
    title={title}
  >
    <DeleteItemModal
      item={item}
      onClose={onClose}
      onDelete={onDelete}
      projectId={projectId}
      revisionId={revisionId}
    />
  </CustomModal>
);
